<template>
  <div class="life-page">
    <el-tabs v-model="activeTab" class="wechat-tabs" @tab-click="syncTab">
      <el-tab-pane label="跳转配置" name="config">
        <section class="life-panel">
          <el-alert
            title="AppID 和 AppSecret 保留在微信服务模块配置中，本页不保存、不修改这些凭证。二维码跳转会查询 Scheme 链接，没有有效链接时自动生成。"
            type="info"
            :closable="false"
            show-icon
          />
          <el-alert
            v-if="module.configAvailable === false"
            class="wechat-gap"
            title="配置表尚未就绪。页面仍显示模块默认值，保存前请先执行微信配置脚本。"
            type="warning"
            :closable="false"
            show-icon
          />
          <el-descriptions class="wechat-gap" :column="2" border size="small">
            <el-descriptions-item label="AppID">{{ module.appId || '未配置' }}</el-descriptions-item>
            <el-descriptions-item label="AppID 来源">{{ sourceLabel(module.appIdSource) }}</el-descriptions-item>
            <el-descriptions-item label="AppSecret">{{ module.secretConfigured ? '已配置' : '未配置' }}</el-descriptions-item>
            <el-descriptions-item label="AppSecret 来源">{{ sourceLabel(module.secretSource) }}</el-descriptions-item>
            <el-descriptions-item label="配置状态">{{ module.persisted ? '已保存到数据库' : '尚未保存，当前为模块默认值' }}</el-descriptions-item>
          </el-descriptions>
        </section>

        <section class="life-panel">
          <el-form ref="form" :model="form" :rules="rules" label-width="140px" style="max-width: 640px">
            <el-form-item label="跳转页面" prop="pagePath">
              <el-input v-model="form.pagePath" placeholder="/pages/home/index" maxlength="200" />
            </el-form-item>
            <el-form-item label="环境版本" prop="envVersion">
              <el-select v-model="form.envVersion" style="width: 220px">
                <el-option label="正式版 release" value="release" />
                <el-option label="体验版 trial" value="trial" />
                <el-option label="开发版 develop" value="develop" />
              </el-select>
            </el-form-item>
            <el-form-item label="允许非正式版">
              <el-switch v-model="form.allowNonRelease" active-value="Y" inactive-value="N" />
              <span class="wechat-hint">体验版或开发版需要打开</span>
            </el-form-item>
            <el-form-item label="有效期（天）" prop="validityDays">
              <el-input-number v-model="form.validityDays" :min="1" :max="30" :step="1" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="saving" @click="save">保存</el-button>
            </el-form-item>
          </el-form>
        </section>
      </el-tab-pane>
      <el-tab-pane label="Scheme 链接" name="schemes" lazy>
        <wechat-scheme-list />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getWechatConfig, saveWechatConfig } from '@/api/dev/wechatApi'
import WechatSchemeList from './schemeList.vue'

export default {
  name: 'WechatConfig',
  components: { WechatSchemeList },
  data() {
    return {
      activeTab: this.$route.query.tab === 'schemes' ? 'schemes' : 'config',
      saving: false,
      module: {},
      form: {
        pagePath: '',
        envVersion: 'release',
        allowNonRelease: 'N',
        validityDays: 29
      },
      rules: {
        pagePath: [{ required: true, message: '请填写跳转页面', trigger: 'blur' }],
        envVersion: [{ required: true, message: '请选择环境版本', trigger: 'change' }],
        validityDays: [{ required: true, message: '请填写有效期', trigger: 'change' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    syncTab(tab) {
      const next = tab.name === 'schemes' ? { tab: 'schemes' } : {}
      if (this.$route.path === '/pages/dev/wechatConfig' && (this.$route.query.tab || '') === (next.tab || '')) {
        return
      }
      this.$router.replace({ path: '/pages/dev/wechatConfig', query: next })
    },
    sourceLabel(source) {
      return ({ MODULE: '模块配置', MAPPING: '配置中心', NONE: '未配置' })[source] || '未配置'
    },
    async load() {
      try {
        const res = await getWechatConfig()
        const data = res.data || {}
        this.module = data
        this.form = {
          pagePath: data.pagePath || '',
          envVersion: data.envVersion || 'release',
          allowNonRelease: data.allowNonRelease === 'Y' ? 'Y' : 'N',
          validityDays: Number(data.validityDays || 29)
        }
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          await saveWechatConfig({
            pagePath: this.form.pagePath,
            envVersion: this.form.envVersion,
            allowNonRelease: this.form.allowNonRelease,
            validityDays: this.form.validityDays
          })
          this.$message.success('已保存')
          this.load()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../travel/life.scss';

.wechat-tabs {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 16px 8px;
}

.wechat-gap {
  margin-top: 16px;
}

.wechat-hint {
  margin-left: 12px;
  color: #6b7280;
  font-size: 12px;
}
</style>
